const chuahoanthanh = () => ({
  table: {
    width: "100%",
    height: "96%",
    fontSize: "14px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  table_ct: {
    width: "100%",
    height: "400px",
    fontSize: "0.85vw",
    overflow: "auto",
  },
  tablenhiemvu: {
    textAlign: "center",
    width: "97%",
    marginLeft: "5px",
    marginRight: "5px",
    fontSize: "0.85vw",
    borderSpacing: "0",
    borderCollapse: "collapse",
    marginTop: "5px",
  },
  tablenhiemvu_th: {
    cursor: "pointer",
    borderWidth: "1px",
    borderColor: "#4f7edb",
    borderStyle: "solid",
    textAlign: "center",
    backgroundImage: "linear-gradient(to bottom, #1f2445 , #1f2445)",
    position: "sticky",
    top: 0,
    //color: "#2e2f2f",
    zIndex: 4,
  },
  tablenhiemvu_ct_th: {
    border: "1px solid #4f7edb",
    top: 0,
    position: "sticky",
    borderStyle: "solid",
    textAlign: "center",
    borderColor: "#4f7edb",
    width: "50%",
  },
  tablenhiemvu_td: {
    border: "1px solid #4f7edb",
    color: "#00ec00",
    fontWeight: "700",
    textAlign: "left",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "blue",
    },
  },
  tablenhiemvu_ct_td: {
    border: "1px solid #4f7edb",
    color: "#006457",
    fontWeight: "700",
    textAlign: "left",
    width: "50%",
  },
  tablenhiemvu_td_number: {
    border: "1px solid #4f7edb",
    color: "#006457",
    fontWeight: "700",
    textAlign: "right",
  },
  tablenhiemvu_td_cap: {
    border: "1px solid #4f7edb",
    color: "#ff9e00",
    fontWeight: "700",
    textAlign: "left",
  },
  tablenhiemvu_td_cap_number: {
    border: "1px solid #4f7edb",
    color: "#ff9e00",
    fontWeight: "700",
    textAlign: "right",
  },
  tooltip: {
    fontWeight: "400",
    textAlign: "center",
    fontSize: "1vw",
    color: "#000000",
  },
});

export default chuahoanthanh;
